import { jsx } from 'react/jsx-runtime';

function u({className:t,children:o,color:i,onClick:r=()=>{}}){let e="white-button text-[#36597D]";switch(i){case"white":e="white-button text-[#36597D]";break;case"gradient":e="gradient-button text-gray-50";break}return jsx("button",{onClick:r||(()=>{}),className:`ui-rounded-full ${e} ${t}`,children:o})}function a({text:t,onClick:o}){return jsx("button",{onClick:o,className:"ui-shadow-neumorphism rounded-full",children:jsx("p",{children:t})})}

export { u as a, a as b };
